import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";
import Video from "./Video";

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>

			<Slider />
			<Video />

			{/* <div className="container" style={{display:'flex',width:'100%',marginBottom:'25px'}}>
			<div className="col-md-2" style={{background:'orange',color:'maroon',display:'flex',alignItems:'center',justifyContent:'center',borderRadius:'0px 0px 15px 15px'}}>
				<h4 style={{fontWeight:'600',color:'maroon'}}>Latest Updates</h4>
			</div>
			<div className="col-md-10" style={{background:'maroon',padding:'5px',borderRadius:'0px 0px 15px 15px',display:'flex',alignItems:'middle'}}>
				<Marquee speed={50} gradient={false} pauseOnHover>
					<div class="news_post_title" style={{padding:'0px'}}><p style={{color:'white',fontSize:'12pt'}}>For enquiries and booking, Contact at +91 471 246 6830</p></div>
				</Marquee>
			</div>
	  </div> */}

			{/* ---
			<div class="booking-container">

				
				<div class="booking-box single">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2972/2972357.png" alt="Single Day Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Single Day Pooja</h3>
					<p>Book pooja for a specific auspicious day with full temple rituals.</p>
					
					<div class="book-btn">
						<a href="https://booking.makreritemple.in/">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				
				<div class="booking-box multiple">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Multiple Day Pooja</h3>
					<p>Schedule pooja services for several days or festivals.</p>
					
					<div class="book-btn">
						<a href="https://booking.makreritemple.in/multiple.aspx">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				
				<div class="booking-box ekanikka">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2331/2331944.png" alt="e-kanikka" />
					</div>
					<h3 className="books-3-ways">E-Kanikka</h3>
					<p>Offer digital donations securely to the deity from anywhere.</p>
					
					<div class="book-btn">
						<a href="https://booking.makreritemple.in/Donation.aspx">
							Donate Now <span>➜</span>
						</a>
					</div>

				</div>

			</div>

			---- */}

			{/* <div className="row">
				<LatestNews />
			</div> */}

			<div class="container-" style={{ marginTop: '60px',marginBottom:'50',margin:'50px;' }}>
				<div className="row">
					<div className="col-12 col-md-7">
						<p className="about" >
							ജഗദ് ഗുരുവായ ശ്രീകൃഷ്ണഭഗവാനും ജ്ഞാനമൂർത്തിയായ ആഞ്ജനേയസ്വാമിയും തുല്യപ്രാധാന്യത്തിൽ കുടികൊള്ളുന്ന ക്ഷേത്രമാണ് ശ്രീകൃഷ്ണമാരുതി ക്ഷേത്രം. തൃശ്ശൂർ ജില്ലയിൽ കൊടുങ്ങല്ലൂർ താലൂക്കിലെ എടവിലങ്ങ് കാരയിലാണ് ശ്രീകൃഷ്ണമാരുതിക്ഷേത്രം നില കൊളളുന്നത്.മറ്റു ക്ഷേത്രങ്ങളിൽ ആഞ്ജനേയൻ വൈഷ്ണവ സങ്കല്പത്തിലാണ് പ്രതിഷ്ഠയെങ്കിൽ ഇവിടെ ഹനുമാൻ സ്വാമി ശൈവരൂപത്തിൽ കുടിയിരിക്കുന്നു എന്നതും സവിശേഷതയാണ്. വൈഷ്ണവ രൂപത്തിൽ ശ്രീകൃഷ്ണ ഭഗവാനും ശാക്തേയ രൂപത്തിൽ തണ്ണികുളങ്ങര ഭദ്രകാളി ദേവിയും നിറസാന്നിധ്യമായി കുടികൊള്ളുന്ന ശൈവ വൈഷ്ണവ സംഗമ ക്ഷേത്രമാണിവിടം. കാരയിൽ കുഞ്ഞിവേലു മുത്തപ്പനാൽ സ്ഥാപിതമായ ശ്രീകൃഷ്ണമാരുതിക്ഷേത്രത്തിന് മൂന്ന് തലമുറകളുടെ കാലപ്പഴക്കമുണ്ട്. മീനമാസത്തിലെ രോഹിണി നക്ഷത്രത്തിലാണ് ഇവിടുത്തെ മഹോത്സവം. അന്നേദിവസം ആഞ്ജനേയ സ്വാമിക്ക് രൂപക്കളമെഴുത്തും പാട്ടും കദളി പഴക്കുല സമർപ്പണവും നടത്തിവരുന്നു. ഹനുമാൻ സ്വാമിയുടെ നടയിൽ കുട്ടികളെ അടിമയിരുത്തുന്ന ചടങ്ങ് ഈ ക്ഷേത്രത്തിലെ സവിശേഷതയാണ്. ദിവസേന രണ്ട് നേരം പൂജയും ശനിയാഴ്ചകളിൽ സങ്കടമോചന സ്തോത്രം ജപിച്ചുകൊണ്ടുള്ള വിശേഷാൽ പൂജയും നാളികേര മുട്ടിറക്കലും നടന്നു വരുന്നു. വടമാല, വെറ്റിലമാല, നാരങ്ങ മാല, പേരാൽ മൊട്ടിൻ്റെ മാല, സിന്ദൂരച്ചാർത്ത്, അവിൽ നിവേദ്യം, സമ്പൂർണസേവ, പുഷ്പാഭിഷേകം എന്നിവയാണ് മറ്റു പ്രത്യേക വഴിപാടുകൾ.
						</p>
					</div>
					<div className="col-12 col-md-5" >
					<div style={{ display: 'flex', height:'50vh', alignItems: 'center', justifyContent: 'center',backgroundImage:'url(./images/maruthi.png)',backgroundSize:'cover',backgroundPosition:'center',margin:'50px'}}>

					</div>
						{/* <img src="./images/home.jpeg" alt="Maruthi Temple" style={{ width: '100%', border: '1px inset silver' }} /> */}
					</div>

				</div>
			</div>


			{/* <div
				className="container animated-border"
				style={{
					marginTop: '50px',
					marginBottom: '50px',
					background: 'white',
					borderRadius: '15px'
				}}
			>
				<div className="row">
					<div
						className="col-12 col-md-5"
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: '25px'
						}}
					>
						<img
							src="./images/hanuman.png"
							alt="Maruthi Temple"
							style={{ width: '100%' }}
						/>
					</div>

					<div
						className="col-12 col-md-7"
						style={{
							display: 'flex',
							flexDirection:'column',
							alignItems: 'center',
							justifyContent: 'center'
						}}
						
					>
						<h3 className="hheading" style={{paddingLeft:'50px',paddingTop:'50px'}}>കുട്ടി​കളെ ഹനുമാൻ‍ സ്വാമിയുടെ നടയിൽ അടിമയിരുത്തുന്ന ചടങ്ങ്</h3>
						<p className="about">
							ശ്രീകൃഷ്ണമാരുതി ക്ഷേത്രത്തിലെ പ്രധാന ചടങ്ങാണ് കുട്ടികളെ അടിമയിരുത്തൽ. അടിമയിരുത്തുന്നത് വിദ്യാവർദ്ധനവിനും ബുദ്ധിഗുണത്തിനും ബാലാരിഷ്ടത മാറുന്നതിനും ഉത്തമമാണ്. <br />
ഹനുമാൻ സ്വാമിയുടെ നടയിൽ കുട്ടികളെ അടിമയിരുത്തുന്നതിലൂടെ കുട്ടിയും സ്വാമിയും തമ്മിൽ ഗുരുശിഷ്യ ബന്ധമുണ്ടാകുന്നു. കുട്ടിയുടെ ബാല്യം, കൗമാരം, യൗവനം, വാർദ്ധക്യം തുടങ്ങി ജീവിതാവസാനം വരെ ഹനുമാൻസ്വാമി കൂടെയുണ്ടാകണമെന്ന പ്രാർത്ഥനയോടെയാണ് കുട്ടികളെ അടിമയിരുത്തുന്നത്. തൻ്റെ രക്ഷയ്ക്ക് ഹനുമാൻ സ്വാമി എപ്പോഴും കൂടെയുണ്ടെന്ന വിശ്വാസം കുട്ടികളുടെ മനസ്സിൽ ഉണ്ടാക്കാൻ ഇത് സഹായിക്കും.വിജയത്തിലേക്കുള്ള യാത്രയിൽ കുട്ടികൾക്ക് മനോബലം വർദ്ധിക്കുവാൻ‍ സഹായിക്കും.  മീനമാസത്തിലെ രോഹിണി നക്ഷത്രത്തിലാണ് ഈ ചടങ്ങ്. ഒരു വയസിനു ശേഷം 10 വയസ് വരെ അടിമയിരുത്താം. <br />
 ഏഴ് ദിവസം വ്രതം ആചരിക്കണം. ഒരു കിഴിപ്പണവും ഫലമൂലാദികളും സമർപ്പിച്ചാണ് ചടങ്ങ് നടത്തുന്നത്. 

						</p>
					</div>
				</div>
			</div> */}




			{/* <div class="grouped_sections" style={{backgroundImage:'url(./images/makreri.jpeg)',backgroundSize:'cover',backgroundAttachment:'fixed',backgroundPosition:'center'}}>
   
		<div class="container">
			<div class="row">

				

				
			</div>
		</div>
	</div> */}

			{/* <div class="container" style={{paddingTop:'75px', paddingBottom:'75px'}}>
		<div class="row">
			<div class="col-md-5">
				<div className="fund">
					<img src="./images/suvarnadarsan.png" alt="Suvarna Darsanam" style={{width:'100%',borderRadius:'15px'}} />
					<center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75" className="btn btn-primary" style={{width:'150px',background:'orange',color:'maroon',border:'none',fontSize:'14pt',fontWeight:'700',marginTop:'15px'}}>Book </Link></center>
				</div>
			</div>
			<div class="col-md-7">
				<div className="fund">
					<img src="./images/bhadratha.png" alt="Suvarna Darsanam" style={{width:'100%',borderRadius:'15px'}} />
					<center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72" className="btn btn-primary" style={{width:'150px',background:'orange',color:'maroon',border:'none',fontSize:'14pt',fontWeight:'700',marginTop:'15px'}}>Book </Link></center>
				</div>
			</div>
		</div>
	</div> */}
			{/* <div className="gosala">
			<div className="overlay">
				<div class="gosaladonate">
					<Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx" className="btn btn-primary" style={{padding:'20px',background:'orange',color:'maroon',fontSize:'14pt',fontWeight:'400',border:'1px solid orange'}}>Goshala Donation</Link>
					<Link to="https://booking.sreepadmanabhaswamytemple.org/GoldenGrace.aspx" className="btn btn-primary" style={{padding:'20px',background:'orange',color:'maroon',fontSize:'14pt',fontWeight:'400',border:'1px solid orange'}}>Donate Golden Grace & Grandeur</Link>
				</div>
			</div>
	</div> */}




		</div>

	);
}

export default Home;